module.exports = __webpack_public_path__ + "img/PIMAX.b388d3e1.png";